import React, { Component } from 'react';
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import { Table } from 'react-bootstrap';
import 'react-table/react-table.css'
import 'react-dropdown/style.css';
import './style.css';
import ReactTable from "react-table";

class Content extends Component {

    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
      }

    constructor(props) {
        super(props);              

            this.state = {
            orders: [],
            orderStatus: 'all',
            userToken: localStorage.getItem('userToken'),
            sortOptions: [
              {
                id: 'count_outstanding',
                desc: true,
              },
            ]
        };       
              
        const { location } = this.props
        
        if (location.pathname !=='/') {

            var pathArray = location.pathname.split('/');

            //pathArray[1] = product
            //pathArray[2] = status value
                
            //console.log('arr: '+  pathArray[1])
            
            this.state = {        
                orderStatus : pathArray[1]
            };
        }
       
    }    

    componentDidMount() {     
      this.getOrders(process.env.REACT_APP_NODE_ROOT_URL+'/reports/dash-orders/');     
    }   

    getOrders = (url) => {
        fetch(url, {
          method: 'GET',   
          headers: {
          'Accept': 'application/json',
          'bwToken': this.state.userToken
          }      
      }).then(res => res.json())
        .then(orders => this.setState({ orders }));       
    }

    handleStatusClick = (e) => {
    e.preventDefault();    
    
        const target = e.target;
    
        e.target.value = null; 
    }

    onStatusClick = i => {      
      this.getOrders(process.env.REACT_APP_NODE_ROOT_URL+'/orders/o/status/'+i);
    }

    onMethodClick = i => {      
      this.getOrders(process.env.REACT_APP_NODE_ROOT_URL+'/orders/o/method/'+i);
    }

    render(){
      
        return (
        <div className="page-wrapper">
            
            <div className="container-fluid">
               
                <div className="row">					
                    <div className="col-lg-12">
                                 
                        <div className="card">
                        
                            <div className="card-title"> 
                            <h3>
                              <a data-toggle="collapse" href="#collapseOutgoing" aria-expanded="true" aria-controls="collapseOutgoing" id="heading-example" className="d-block">                                
                              <h3 className="text-primary">Orders</h3>
                                <i className="fa fa-chevron-down pull-right"></i>
                              </a>
                            </h3>
                            </div>
                            <div className="collapse show" id="collapseOutgoing">
                            
                            <div className="card-body">                            
                            <div className="table-responsive">
                               
                            <ReactTable
                              ref={(r) => (this.reactTable = r)}
                              data={this.state.orders}
                              sorted={this.state.sortOptions}
                              onSortedChange={(val) => {
                                this.setState({ sortOptions: val });                                
                              }}
                              filterable
                              noDataText="Loading dashboard..."
                              loading={this.state.loading}
                              defaultFilterMethod={(filter, row) =>
                                String(row[filter.id]).toLowerCase().includes(filter.value.toLowerCase())
                              }
                              columns={[
  {
    Header: '',
    columns: [
      {
        Header: 'Client',
        accessor: 'cl_name',
        Cell: row => <strong>{row.value}</strong>,
        width: 160
      },
      {
        Header: 'New',
        accessor: 'count_new',
        Cell: row => <strong>{row.value}</strong>,
        width: 60,
        style: { textAlign: 'center' }
      },
      {
        Header: 'Processing',
        accessor: 'count_process',
        Cell: row => <strong>{row.value}</strong>,
        width: 75,
        style: { textAlign: 'center' }
      },
      {
        Header: 'Ready for Pick Up',
        accessor: 'count_ready',
        Cell: row => <strong>{row.value}</strong>,
        width: 105,
        style: { textAlign: 'center' }
      },
      {
        Header: 'Outstanding Orders',
        id: 'count_outstanding',
        accessor: d =>
          (parseInt(d.count_new) || 0) +
          (parseInt(d.count_process) || 0) +
          (parseInt(d.count_ready) || 0),
        Cell: row => <strong>{row.value}</strong>,
        filterable: false,
        width: 100,
        style: { textAlign: 'center' }
      },
      {
        Header: 'Rate (Orders/Hr)',
        accessor: 'cl_order_fill_rate',
        Cell: row => <strong>{row.value}</strong>,
        width: 85,
        style: { textAlign: 'center' },
        filterable: false
      },
      {
        Header: 'Hrs Required',
        accessor: 'Hrs Required',
        Cell: row => <strong>{row.value}</strong>,
        width: 80,
        style: { textAlign: 'center' },
        filterable: false
      },
      {
        Header: 'Urgent',
        accessor: 'count_urgent',
        Cell: row => <strong>{row.value}</strong>,
        width: 60,
        style: { textAlign: 'center' }
      },
      {
        Header: 'On Hold',
        accessor: 'count_hold',
        Cell: row => <strong>{row.value}</strong>,
        width: 70,
        style: { textAlign: 'center' }
      },
      {
        Header: 'Canceled',
        accessor: 'count_canceled',
        Cell: row => <strong>{row.value}</strong>,
        width: 70,
        style: { textAlign: 'center' }
      },
      {
        Header: 'Mis-shipped',
        accessor: 'count_missed',
        Cell: row => <strong>{row.value}</strong>,
        width: 80,
        style: { textAlign: 'center' }
      },
    ],
  },
]}

                            />


                           </div>

                            </div>
                        </div>
                    </div>
                </div>               
                <div className="row">   
                <div className="col-lg-4">
                        
                      </div>
                  </div>


              </div>

              <footer className="footer"> © 2024 All rights reserved. Brand Warehouse</footer>

            </div>
        </div>
                )
    }
}
export default withRouter(Content);